<template>
  <div class="posts-off-back">
    <div class="ly-card">
      <el-radio-group v-model="searchFormData.is_process" @change="search">
        <el-radio-button :label="-1">全部</el-radio-button>
        <el-radio-button :label="false">待处理</el-radio-button>
        <el-radio-button :label="true">已处理</el-radio-button>
      </el-radio-group>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:action="row">
        <template v-if="row.is_process">
          <span v-if="row.is_banned">已封禁</span>
          <span v-else>已忽略</span>
        </template>
        <template v-else>
          <el-button @click="ingevoegd(row)" type="text" size="mini">忽略</el-button>
          <el-button @click="Off(row)" type="text" size="mini" class="el-button--danger">封贴</el-button>
        </template>
      </template>
      <template v-slot:tip_off_count="row">
        <el-button type="text" size="mini" @click="getDetail(row)">{{ row.tip_off_count }}</el-button>
      </template>
      <template v-slot:content="row">
        <el-button type="text" size="mini" @click="detail(row)">{{ row.content | brief }}</el-button>
      </template>
    </ly-table>
    <el-drawer title="举报详情" :visible.sync="drawer" direction="rtl">
      <ly-table
        ref="lyTableDetail"
        :getTableData="getTableDataDetal"
        :searchFormData="searchFormDataDetail"
        :tableHeader="tableHeaderDetail"
      ></ly-table>
    </el-drawer>
  </div>
</template>
<script>
import { RadioGroup, RadioButton, Drawer } from 'element-ui';
import LyTable from '@/components/LyTable';
import cPosts from '@/api/cPosts';
import { postsOffBackTable } from '@/utils/communityHeader';

export default {
  name: 'PostsBack',
  components: { LyTable, ElRadioButton: RadioButton, ElRadioGroup: RadioGroup, ElDrawer: Drawer },
  data() {
    return {
      tableHeader: postsOffBackTable,
      getTableData: cPosts.replyTipOffList,
      searchFormData: {
        is_process: -1
      },
      drawer: false,
      getTableDataDetal: cPosts.replyTipOffDetail,
      tableHeaderDetail: [
        {
          value: 'tip_off_user_name',
          name: '举报人'
        },
        {
          value: 'tip_off_time',
          name: '举报时间'
        }
      ],
      searchFormDataDetail: {
        post_id: ''
      }
    };
  },
  mounted() {
    this.search();
  },
  filters: {
    brief(value) {
      if (!value || value.length < 20) return value;
      return `${value.substring(0, 20)}...`;
    }
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    },
    Off(row) {
      cPosts
        .replyTipOff({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '封贴成功！');
            this.search();
          }
        });
    },
    ingevoegd(row) {
      cPosts
        .ignoreReply({
          post_id: row.id
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '忽略成功！');
            this.search();
          }
        });
    },
    getDetail(row) {
      this.drawer = true;
      this.searchFormDataDetail = {
        post_id: row.id
      };
      setTimeout(() => this.$refs.lyTableDetail.setData(), 0);
    },
    detail(row) {
      this.$router.push(`/${this.$route.params.user_id}/community/content/${row.post_id}`);
    }
  }
};
</script>
